import { render, staticRenderFns } from "./ChangePassword.vue?vue&type=template&id=c0710c04&scoped=true&lang=pug&"
import script from "./ChangePassword.vue?vue&type=script&lang=js&"
export * from "./ChangePassword.vue?vue&type=script&lang=js&"
import style0 from "./ChangePassword.scss?vue&type=style&index=0&id=c0710c04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0710c04",
  null
  
)

export default component.exports